import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveValue } from 'styled-system';

import { truncate, TruncateProps, Text, media, themeGet, HAS_PSUDO_SKELETON } from '@packages/ui';

const ProductTitle = styled.div`
  flex: 2;
  ${media.to.sm`
    max-height: ${themeGet.space(3)};
  `}
`;

const Description = styled(Text)<TruncateProps>`
  ${truncate}
`;

export const ProductDescription: React.FC<{
  title: string;
  numberOfDescriptionLines?: ResponsiveValue<number>;
  lineHeight?: ResponsiveValue<number>;
  my?: ResponsiveValue<number>;
}> = ({ title, numberOfDescriptionLines = [1, 1, 2, 2, 2], lineHeight = [1.5, 1.5, 2, 2, 2] }) => {
  return (
    <ProductTitle className={HAS_PSUDO_SKELETON} color="kilamanjaro">
      <Description tag="span" fontSize={[4, 4, 6]} linesToShow={numberOfDescriptionLines} lineHeight={lineHeight}>
        {title}
      </Description>
    </ProductTitle>
  );
};
